import { ArrowLeft } from "lucide-react"

import { CreateReportGeneratorPanel } from "@/features/report/creation/CreateReportGeneratorPanel"
import { Button } from "@ui/button"

export function CreateReportGeneratorPage() {
    const navigateToDashboard = () => {
        window.location.pathname = "/report-generator"
    }

    return (
        <CreateReportGeneratorPanel>
            <Button onClick={navigateToDashboard}>
                <ArrowLeft />
                Back to Dashboard
            </Button>
        </CreateReportGeneratorPanel>
    )
}